import { Box, Grid, Typography, useMediaQuery } from '@mui/material';

import image from '../../assets/images/error.png';
// import { gridSpacing } from 'store/constant';
import CustomBtn from 'ui-component/Button';
import HeaderLogo from 'ui-component/HeaderLogo';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ContactUs from './ContactUs';

const ErrorScreen = ({ showHeader, err }: any) => {
    const isMobile = useMediaQuery('(max-width:900px)');
    const [url, setUrl] = useState('https://play.google.com/store/apps/details?id=com.tr.brightup&pli=1');
    const [open, setOpen] = useState(false);
    const [switchcomponent, setSwitchComponent] = useState(false);

    // const navigate = useNavigate();
    const [isPageRefreshed, setIsPageRefreshed] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const errorString = queryParams.get('error');
    const error = errorString ? JSON.parse(decodeURIComponent(errorString)) : null;

    console.log('isPageRefreshed', isPageRefreshed);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        //@ts-ignore
        const userAgent = navigator.userAgent || navigator.vendor || window?.opera;

        console.log('userAgent', userAgent);

        // Check if the user agent contains 'iPhone' or 'iPad' to detect iOS devices
        //@ts-ignore
        const isIOS: boolean = /iPad|iPhone|iPod/.test(userAgent) && !window?.MSStream;

        // Check if the user agent contains 'Android' to detect Android devices
        const isAndroid: boolean = /Android/.test(userAgent);

        console.log('isIOS', isIOS);
        console.log('isAndroid', isAndroid);

        if (isIOS) {
            // Redirect to the Apple App Store URL
            setUrl(`https://apps.apple.com/us/app/brightup-financial-wellness/id1638340315`);
        } else if (isAndroid) {
            // Redirect to the Google Play Store URL
            setUrl(`https://play.google.com/store/apps/details?id=com.tr.brightup&pli=1`);
        }
    }, []);

    useEffect(() => {
        // Check if the page is being refreshed
        const isRefreshed = performance.navigation.type === performance.navigation.TYPE_RELOAD;

        if (isRefreshed) {
            // Page is being refreshed, set state and redirect
            setIsPageRefreshed(true);
            // error && navigate(-1); // Replace with your desired route
        }
    }, []);

    return (
        <>
            {showHeader && <HeaderLogo />}
            <Grid container sx={{ padding: '20px', height: '60vh' }} alignItems="center">
                <Grid item ml={isMobile ? 0 : 5} md={5} sx={{ display: 'flex', flexDirection: 'column' }} paddingX={2}>
                    <Typography
                        sx={{
                            fontSize: { xs: '16px', md: '36px' },
                            fontWeight: 'bold',
                            color: '#002443',
                            textTransform: 'capitalize'
                        }}
                    >
                        Whoops! Something went wrong.
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: { xs: '12px', md: '18px' },
                            marginTop: '24px',
                            color: '#002443',
                            textTransform: 'capitalize'
                        }}
                    >
                        While we’re busy fixing this, explore other ways to invest in YOU today!
                    </Typography>
                    {!isMobile && (
                        <Box display="flex" sx={{ marginTop: '72px' }}>
                            <CustomBtn label="Download App" sx={{ marginRight: '24px' }} LinkComponent={Link} target="_blank" href={url} />
                            <CustomBtn
                                label="Contact Us"
                                variant="outlined"
                                onPress={() => {
                                    handleClickOpen();
                                }}
                            />
                        </Box>
                    )}
                </Grid>
                <Grid item md={6} paddingX={2} pt={isMobile ? 4 : 2}>
                    <img src={image} alt="error" style={{ width: '100%' }} />
                </Grid>
                {isMobile && (
                    <Box sx={{ width: '100%', marginTop: '30px' }}>
                        <CustomBtn label="Download App" sx={{ marginBottom: '24px' }} LinkComponent={Link} target="_blank" href={url} />
                        <CustomBtn
                            label="Contact Us"
                            variant="outlined"
                            onPress={() => {
                                handleClickOpen();
                            }}
                        />
                    </Box>
                )}
            </Grid>
            <ContactUs
                open={open}
                handleClose={handleClose}
                switchComponent={switchcomponent}
                setSwitchComponent={setSwitchComponent}
                errorMessage={error ? error : err}
            />
        </>
    );
};

export default ErrorScreen;
